export default "__VITE_ASSET__DssAL$Bd__"